var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7279 12.539C16.4026 12.539 16.9689 13.0959 16.8658 13.7622C16.2605 17.6822 12.9047 20.5927 8.85737 20.5927C4.37947 20.5927 0.75 16.9633 0.75 12.4864C0.75 8.79799 3.55211 5.3622 6.70684 4.58536C7.38474 4.41799 8.07947 4.89484 8.07947 5.59273C8.07947 10.3212 8.23842 11.5443 9.13632 12.2096C10.0342 12.8748 11.09 12.539 15.7279 12.539Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1423 8.6016C20.196 5.5637 16.4644 0.666861 11.9171 0.751072C11.5634 0.757388 11.2802 1.05212 11.2644 1.40476C11.1497 3.90265 11.3044 7.13949 11.3908 8.60686C11.4171 9.0637 11.776 9.42265 12.2318 9.44897C13.7402 9.53528 17.095 9.65318 19.5571 9.28055C19.8918 9.23002 20.1371 8.93949 20.1423 8.6016Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.bf040287c0aa057860aa27f2b418f061.svg";
export { ForwardRef as ReactComponent };